
import showdown from "showdown" 

export default function(o, done){

  var type = 'news'

  var label = o.util.getTranslation(o, type)

  document.title = `Open Memory Box | ${label}`

  var lang = o.store('lang')

  var subscribeLabel = o.util.getTranslation(o, 'subscribe')
  var unsubscribeLabel = o.util.getTranslation(o, 'unsubscribe')
  var newsletterLabel = o.util.getTranslation(o, 'newsletter')
  var emailLabel = o.util.getTranslation(o, 'email')

  var converter = new showdown.Converter({
    simpleLineBreaks: true,
    openLinksInNewWindow: true,
  })

  o.data.content(o, function(contentData){

    var subscribeClick = function(unsubscribe){
      var email = emailInput.val()
      if(!email){
        infoDiv.html(o.util.getTranslation(o,'subscribeErrorEmail'))
      } else {
        o.util.newsSubscription(email,o.store('lang'),unsubscribe,function(error){
          if(error){
            infoDiv.html(o.util.getTranslation(o,'serverError'))
          } else {
            if(unsubscribe){
              infoDiv.html(o.util.getTranslation(o,'unsubscribeSuccess'))
            } else {
              infoDiv.html(o.util.getTranslation(o,'subscribeSuccess'))
            }
          }
        })
      }
    }

    var content = _.find(contentData, {view: type})

    var markdown = content[lang]

    var html = converter.makeHtml(markdown)

    var textDiv =
      $('<div>')
      .css({
        textTransform: 'none',
        marginTop: '1.3rem',
      })
      .append(html)

    var newsletterDiv =
      $('<div>')
      .css({
        marginBottom: '1rem',
        color: o.colors.red,
      })
      .append(newsletterLabel)

    var emailDiv =
      $('<div>')
      .css({
        marginBottom: '0.2rem',
      })
      .append(emailLabel)

    var emailInput =
      o.component.input(o,true)
      .css({
        display: 'block',
        width: '15rem',
        maxWidth: '90%',
        margin: '0 auto',
        marginBottom: '0.1em',
      })

      .keyup(function(e) {
        if (e.keyCode === 13) {
            subscribeClick()
        }
      })

    var subscribeDiv = o.component.button(o, subscribeLabel, function(){subscribeClick()})

    var unsubscribeDiv = o.component.button(o, unsubscribeLabel, function(){subscribeClick(true)})

    var buttonsDiv = $('<div>')
    .css({
      marginTop: '0.05rem'
    })
    .append([
      subscribeDiv
      .css({
        margin: '0.25rem'
      }),
      o.component.spacer(o)
      .css({
        margin: '0.25rem'
      }),
      unsubscribeDiv
      .css({
        margin: '0.25rem'
      }),
    ])

    var infoDiv =
      $('<div>')
      .css({
        color: o.colors.red,
        textTransform: 'none',
        marginBottom: '1.2em',
        marginTop: '-0.2rem',
      })
      .html('&nbsp;')

    var wrapperDiv = 
      $('<div>')
      .css(o.morePagesTextCss)
      .append([
        newsletterDiv,
        emailDiv,
        emailInput,
        buttonsDiv,
        infoDiv,
        textDiv,
      ])

    var mainDiv = 
      $('<div>')
      .css({
        flex: '0 1 auto',
        justifyContent: 'center',
        overflowY: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        minHeight: 0,
        zIndex: 1,
      })
      .append([
        wrapperDiv,
      ])

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      o.component.menu(o)
      .css({
        flex: '0 0 auto',
        width: '100%',
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

      mainDiv,

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

    ])

    var observer =
      new MutationObserver(function(){
        if (document.body.contains(div[0])){

          observer.disconnect()

          emailInput.focus()

        }
      })

    observer.observe(document.body, {childList: true});

    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/news/news.js